import { useEffect, useRef } from "react";
import jsQR from "jsqr";
import { showErrorMessage } from "../../../helpers/MessagesHelper";

interface ScannerQRProps {
  contentScan: (content: string) => void;
  cameraOn: boolean;
}

export function ScannerQR({ contentScan, cameraOn }: ScannerQRProps) {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const stopCamera = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      const stream = videoElement.srcObject as MediaStream | null;
      if (stream) {
        const tracks = stream.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
      }
    }
  };

  useEffect(() => {
    const startQrReader = () => {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      if (videoElement.videoWidth === 0) {
        requestAnimationFrame(startQrReader);
        return;
      }

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      if (!context) return;

      canvas.width = videoElement.videoWidth;
      canvas.height = videoElement.videoHeight;
      context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const code = jsQR(imageData.data, imageData.width, imageData.height);

      if (code) {
        stopCamera();
        const qrContent = code.data;
        contentScan(qrContent);
      }

      requestAnimationFrame(startQrReader);
    };

    if (videoRef.current && cameraOn) {
      navigator.mediaDevices.enumerateDevices().then((devices) => {
        const hasCameras = devices.some(
          (device) => device.kind === "videoinput"
        );
        if (!hasCameras) {
          showErrorMessage(404, "Nenhuma Câmera disponível");
          stopCamera();
        } else {
          const videoElement = videoRef.current;
          if (videoElement) {
            videoElement.onloadedmetadata = startQrReader;

            navigator.mediaDevices
              .getUserMedia({ video: { facingMode: "environment" } })
              .then((stream) => {
                const videoElement = videoRef.current;
                if (videoElement) {
                  videoElement.srcObject = stream;
                }
              })
              .catch((error) => {
                showErrorMessage(
                  error?.response?.data?.error?.statusCode,
                  error?.response?.data?.error?.message
                );
                stopCamera();
              });
          }
        }
      });
    }

    return () => {
      stopCamera();
    };
  }, [contentScan, cameraOn]);

  return (
    <div className="text-center">
      <h1>Leitor QR Code</h1>
      <video
        className="w-100 border border-primary"
        id="qr-video"
        ref={videoRef}
        autoPlay={true}
      ></video>
    </div>
  );
}
